// Copyright (c) StrangeBee 2023

import client from '@Client';
import { AttachmentType } from 'thehive-sdk';
import { slugify } from './string';

function getFileName(filename: string): string {
    return filename.slice(0, ((filename.lastIndexOf('.') - 1) >>> 0) + 2);
}

function getFileExtension(filename: string): string {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
}

export const exportToJSON = (filename: string, data: Record<string, any>): Promise<void> => {
    const json = JSON.stringify(data);
    return downloadFile(filename + '.json', json, 'application/json');
};

export const downloadFile = async (
    fileName: string,
    fileContent: string | string[],
    mimeType: string,
    base64 = false,
): Promise<void> => {
    const blob = new Blob(Array.isArray(fileContent) ? fileContent : [fileContent], { type: mimeType });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = base64 ? (fileContent as string) : href;
    link.download = `${slugify(getFileName(fileName))}.${getFileExtension(fileName)}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const downloadByUrl = (fileName: string, downloadUrl: string): void => {
    const req = new XMLHttpRequest();
    req.open('GET', downloadUrl, true);
    req.responseType = 'blob';
    req.onload = async function () {
        const blob = req.response;
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = `${slugify(getFileName(fileName))}.${getFileExtension(fileName)}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    req.send();
};

export const caseReportTemplateImageUpload = async (
    caseTemplateId: string,
    image: File,
): Promise<AttachmentType | undefined> => {
    const formData = new FormData();
    formData.set('attachments', image);
    formData.set('canRename', 'true');
    try {
        const { attachments = [] } = await client.ReportTemplateController.addAttachment(caseTemplateId, formData);

        const attachment = attachments.find(Boolean);
        return Promise.resolve(attachment);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const onOrganisationImageUpload = async (image: File): Promise<string> => {
    const formData = new FormData();
    formData.set('attachments', image);
    formData.set('canRename', 'true');
    const { attachments = [] } = await client.AttachmentController.create<any, { attachments: AttachmentType[] }>(
        formData,
    );
    const attachment = attachments.find(Boolean);
    return Promise.resolve(client.apiUrl + `/v1/attachment/${attachment?._id || ''}`);
};

export const onCaseImageUpload =
    (caseId: string) =>
    async (image: File): Promise<string> => {
        const formData = new FormData();
        formData.set('attachments', image);
        formData.set('canRename', 'true');
        const { attachments = [] } = await client.CaseController.createAttachments(formData, caseId);
        const attachment = attachments.find(Boolean);
        return Promise.resolve(client.apiUrl + `/v1/case/${caseId}/attachment/${attachment?._id || ''}`);
    };
